// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoLogoOutlinedSvg from "@fishx/icons-svg/es/asn/PtoLogoOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoLogoOutlined = function PtoLogoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoLogoOutlinedSvg
  }));
};

PtoLogoOutlined.displayName = 'PtoLogoOutlined';
export default React.forwardRef(PtoLogoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoLogoOutlined.js
// module id = 3918
// module chunks = 0